import { DateStringValue } from '@unistocks/components/calendar/types';
import { createDate } from '@unistocks/shared/utils/util';

interface IsYearDisabledInput {
  year: DateStringValue;
  minDate: DateStringValue | undefined;
  maxDate: DateStringValue | undefined;
}

/** Whether `year` falls outside the `[minDate, maxDate]` bounds (year granularity). */
export function isYearDisabled({ year, minDate, maxDate }: IsYearDisabledInput): boolean {
  if (!minDate && !maxDate) {
    return false;
  }

  if (minDate && createDate(year).year < createDate(minDate).year) {
    return true;
  }

  if (maxDate && createDate(year).year > createDate(maxDate).year) {
    return true;
  }

  return false;
}
